import { DEFAULT_PAGE } from '../../constants/pagination';
import {
  EMPLOYEE_SORT_ORDER,
  EMPLOYEE_DEFAULT_SORT_COLUMN,
} from '../../constants/sort';
import { SortOrder } from '../sort/sort';

export interface EmployeeGetQueryParams {
  page: number;
  sortOrder: SortOrder;
  sortKey: string;
  employeeId: number;
  isTokyo: boolean;
  isDairen: boolean;
}

export const DefaultEmployeeGetQueryParams: EmployeeGetQueryParams = {
  page: DEFAULT_PAGE,
  sortOrder: EMPLOYEE_SORT_ORDER,
  sortKey: EMPLOYEE_DEFAULT_SORT_COLUMN,
  employeeId: 0,
  isTokyo: true,
  isDairen: false,
};
